"use strict";

define(['app', 'jquery', 'underscore', 'components/switch/index', './template.html'], function (app, $, _, Switch, tmplTranslationSwitch) {
  return app.Marionette.ItemView.extend({
    template: tmplTranslationSwitch,
    ui: {
      liveEditSwitch: '[data-js="live-edit-switch"]'
    },
    events: {
      'change @ui.liveEditSwitch': '_toggleLiveEdit'
    },
    options: {
      switchMessage: 'Phrases'
    },
    templateHelpers: function templateHelpers() {
      return {
        canEditPhrases: this.options.canEditPhrases,
        switchMessage: this.options.switchMessage,
        controlUrl: this.options.controlUrl,
        liveEdit: this.liveEdit
      };
    },
    initialize: function initialize() {
      this.liveEdit = this.options.canEditPhrases && this.options.liveEdit;
      this.switchMessage = this.options.switchMessage;
    },
    onRender: function onRender() {
      if (!this._liveEditSwitch && this.options.canEditPhrases) {
        this._liveEditSwitch = new Switch({
          el: this.ui.liveEditSwitch
        }).render();
      }
    },
    _redirect: function _redirect(editModeParam) {
      var loc = window.location; // get query string without edit mode params and without initial & or ? char

      var search = loc.search.replace(/[?&]live_edit=[01]|[?&]show_phrases/g, '').substring(1); // get href without query string

      var href = loc.href.replace(loc.search, '').split('#')[0]; // append edit param + rest of query string (if any)

      var url = href + '?' + editModeParam + (search.length > 0 ? '&' + search : '');
      document.body.classList.add('page-loading'); // load url without affecting history

      loc.replace(url);
    },
    _toggleLiveEdit: function _toggleLiveEdit() {
      this.liveEdit = !this.liveEdit;

      this._redirect('live_edit=' + (this.liveEdit ? 1 : 0));
    }
  });
});